// extracted by mini-css-extract-plugin
export var option = "_40-0";
export var optionCard = "_40-f";
export var optionContent = "_40-g";
export var optionIcon = "_40-i";
export var optionIconBox = "_40-h";
export var optionLabel = "_40-j";
export var optionPill = "_40-m";
export var optionPillBadge = "_40-p";
export var optionPillIcon = "_40-n";
export var optionPillLabel = "_40-o";
export var optionRadio = "_40-k";
export var optionRadioInner = "_40-l";
export var optionReveal = "_40-2";
export var optionRevealDelay0 = "_40-3";
export var optionRevealDelay1 = "_40-4";
export var optionRevealDelay10 = "_40-d";
export var optionRevealDelay11 = "_40-e";
export var optionRevealDelay2 = "_40-5";
export var optionRevealDelay3 = "_40-6";
export var optionRevealDelay4 = "_40-7";
export var optionRevealDelay5 = "_40-8";
export var optionRevealDelay6 = "_40-9";
export var optionRevealDelay7 = "_40-a";
export var optionRevealDelay8 = "_40-b";
export var optionRevealDelay9 = "_40-c";
export var optionSelected = "_40-1";